import React, { useEffect, useState } from "react";
import Spinner from "../../components/_common/Spinner";
import OneBarChart from  '../../components/_common/BarChart/OneBarChart'
const chart_data = [
  {
    name: "تایید نشده",
    count: 16,
    color:'#f70909'
  },
  {
    name: "تایید نشده اورژانس",
    count: 3,
    color: '#f6811b',
  },
  {
    name: " تایید شده روز",
    count: 2,
    color: '#12db98',
    
  },
  {
    name: "گفتگو حضوری",
    count: 2,
    color: '#11adbe',
    
  }
  
];
export interface InputProps {
  data: any,
  isloading: Boolean; 
}

const Confirmation = ({  data, isloading}: InputProps) => {

  let chartData:any[]=[];
  let flag = false;

  useEffect(() => {  
  }, [])
 
  const getChartData =()=>{
    data.map((item:any)=>{
      chartData.push({name:"تایید نشده", count:item.TotalUnConfirmed,color:'#f70909'});
      chartData.push( {name:"تایید نشده اورژانس", count:item.EmergencyUnConfirmed,color:'#f6811b'});
      chartData.push({name:"تایید شده روز", count:item.Confirmed,color:'#12db98'});
      chartData.push({name:"گفتگو حضوری", count:item.InterviewRequest,color:'#11adbe'});
    })

    chartData.map((item:any)=>{
      if(item.count !==0 ) {
        flag = true;
        return;
      }
    })
  }
 
  return (
    <>
    {isloading === false && (
        getChartData(),
        <>
            { 
              flag &&(
        <OneBarChart data={chartData} label="" dataKey="count"/>
        )
      } 
      {
       flag === false &&
       (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
      }
      </>
     )
     
 }

    {isloading === true && (
        <Spinner />
    )}

    </>
  )
}
export default Confirmation;